export default __webpack_public_path__ + "static/media/hm-net-img.964df966.webp";